// extracted by mini-css-extract-plugin
export default {"link":"Link_link__DDnuY","underlined":"Link_underlined__Hg-Jd"};